import React, { Component } from "react";
import Select from "react-select";
import Loader from "react-loader-spinner";
import ToscaField from "./../../../../components/FormControls/ToscaField";
import Alert from "./../../../../components/Alert";

export default class ShippingInstruction extends Component {
  componentDidMount() {
    this.syncCustomerPickUpConstraint();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.shipTo !== this.props.shipTo ||
      prevProps.orderInventory !== this.props.orderInventory ||
      prevProps.newOrder?.customerPickUp !== this.props.newOrder?.customerPickUp
    ) {
      this.syncCustomerPickUpConstraint();
    }
  }

  getCustomerPickUpState = (shipTo, orderInventory) => {
    let forcedValue = null;
    let disabled = false;

    if (shipTo?.value) {
      const allItemPrices = (orderInventory || [])
        .flatMap((item) => item?.itemPrices || [])
        .filter((price) => !price.discount);

      if (allItemPrices.length > 0) {
        const cpuPrices = allItemPrices.filter(
          (price) => price.tariffUnitId === "CPU",
        );
        const spPrices = allItemPrices.filter(
          (price) => price.tariffUnitId === "SP",
        );
        const isAllCPU = cpuPrices.length === allItemPrices.length;
        const isAllSP = spPrices.length === allItemPrices.length;

        if (isAllCPU) {
          forcedValue = true;
        } else if (isAllSP) {
          forcedValue = false;
        }
        disabled = isAllCPU || isAllSP;
      }
    }

    return { forcedValue, disabled };
  };

  syncCustomerPickUpConstraint = () => {
    const { shipTo, orderInventory, newOrder, onResolvedCustomerPickUpChange } =
      this.props;
    const { forcedValue } = this.getCustomerPickUpState(shipTo, orderInventory);

    if (
      forcedValue !== null &&
      forcedValue !== newOrder?.customerPickUp &&
      onResolvedCustomerPickUpChange
    ) {
      onResolvedCustomerPickUpChange(forcedValue);
    }
  };

  render() {
    let {
      newOrder,
      handleCustomerPickUpChange,
      handleTruckWashRequestedChange,
      shipTo,
      shipToList,
      isSelfPickup,
      DropdownIndicator,
      user,
      onShipToChange,
      reqShipTo,
      address,
      gotoDetails,
      isTruckWashEligible,
      shipToDisabled,
      orderInventory,
      isFetchingInventory,
    } = this.props;

    const { disabled: customerPickUpDisabled } = this.getCustomerPickUpState(
      shipTo,
      orderInventory,
    );

    return (
      <div>
        <div id="orderdiv" className="order-date-mobile">
          <p className="tw-m-0 tw-text-tosca-orange tw-text-left md:tw-text-right">
            Order Date
          </p>
          <p className="tw-m-0 tw-text-left tw-text-gray-600 md:tw-text-right">
            {newOrder.order_date}
          </p>
        </div>
        <div className="md:tw-flex md:tw-items-center tw-mb-6">
          <ToscaField
            name="orderType"
            elementType="input"
            inputType="text"
            value={"form.orderType.value"}
            label="Self Pick-up:"
            optionDisplayLabel="displayValue"
            optionValue="value"
            disabled={true}>
            {isFetchingInventory ? (
              <div className="tw-flex tw-items-center">
                <Loader
                  type="ThreeDots"
                  color="rgba(246,130,32,1)"
                  height="25"
                  width="25"
                />
              </div>
            ) : (
              <input
                className="mr-2 leading-tight tw-h-6 tw-w-6"
                type="checkbox"
                checked={newOrder?.customerPickUp ?? false}
                disabled={customerPickUpDisabled}
                onChange={handleCustomerPickUpChange}
              />
            )}
          </ToscaField>
        </div>
        {isTruckWashEligible && !isSelfPickup && (
          <div className="md:tw-flex md:tw-items-center tw-mb-6">
            <ToscaField
              name="truckWashRequested"
              elementType="input"
              inputType="text"
              value={"form.truckWashRequested.value"}
              label="Truck wash:"
              optionDisplayLabel="displayValue"
              optionValue="value"
              disabled={true}>
              <input
                className="mr-2 leading-tight tw-h-6 tw-w-6"
                type="checkbox"
                checked={newOrder.truckWashRequested}
                onChange={handleTruckWashRequestedChange}
              />
            </ToscaField>
          </div>
        )}

        <div className="md:tw-flex md:tw-items-center tw-mb-6">
          <ToscaField
            name="shipToLocation"
            elementType="input"
            inputType="text"
            value={"form.orderType.value"}
            label={isSelfPickup ? "My Order Location:" : "Ship to location:"}
            optionDisplayLabel="displayValue"
            optionValue="value">
            <Select
              id="ship_to"
              options={shipToList}
              value={shipTo}
              className="react-select"
              components={{ DropdownIndicator }}
              onChange={(option) => onShipToChange(option, user)}
              isDisabled={shipToDisabled}
              backspaceRemovesValue={false}
              isLoading={this.props.isFetchingSourceAddresses}
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  border: reqShipTo
                    ? "1px solid red"
                    : "1px solid rgba(126, 212,247,1)",
                }),
              }}
            />
          </ToscaField>
        </div>

        <div className="md:tw-flex md:tw-items-center tw-mb-6">
          <ToscaField
            name="shipToLocation"
            elementType="input"
            inputType="text"
            value={"form.orderType.value"}
            label={isSelfPickup ? "Location Address:" : "Shipping Address:"}
            optionDisplayLabel="displayValue"
            optionValue="value">
            <textarea
              id="ship-to-address"
              className="form-control remove-border"
              value={address}
              readOnly
            />
          </ToscaField>
        </div>

        <div className="md:tw-flex md:tw-items-center tw-mb-6">
          <ToscaField
            name="shipToLocation"
            elementType="input"
            inputType="text"
            value={"form.orderType.value"}
            label="Transportation Instructions:"
            optionDisplayLabel="displayValue"
            optionValue="value">
            <textarea
              className="form-control remove-border top-border-dark"
              id="transport"
              value={newOrder.transport_instructions}
              readOnly
              placeholder={
                shipTo !== ""
                  ? "To save Transportation Instructions for this location, please contact Customer Experience."
                  : null
              }
            />
          </ToscaField>
        </div>

        <div className="md:tw-flex md:tw-items-center tw-mb-6">
          <ToscaField
            name="shipToLocation"
            elementType="input"
            inputType="text"
            value={"form.orderType.value"}
            label="Loading Instructions:"
            optionDisplayLabel="displayValue"
            optionValue="value">
            <textarea
              className="form-control remove-border top-border-dark"
              id="transport"
              value={newOrder.transport_instructions}
              readOnly
              placeholder={
                shipTo !== ""
                  ? "To save Loading Instructions for this location, please contact Customer Experience."
                  : null
              }
            />
          </ToscaField>
        </div>

        <div className="tw-flex tw-justify-end tw-mt-4">
          <div className="md:tw-w-1/3 hidden"></div>
          <div className="md:tw-w-2/3 md:tw-w-3/3">
            <Alert
              type="warning"
              msg="Include additional instructions for specific orders on Order Details form on the next page."
            />
          </div>
        </div>

        <div className="tw-flex tw-justify-end tw-mt-4">
          <button
            onClick={gotoDetails}
            className="tw-relative tw-bg-tosca-orange hover:tw-bg-orange-700 tw-text-white tw-font-bold tw-py-2 tw-px-4 tw-border-none tw-flex tw-justify-end tw-rounded disabled:tw-bg-gray-500"
            disabled={isFetchingInventory}>
            <span>Continue</span>
          </button>
        </div>
      </div>
    );
  }
}
